<div class="home-container">
    <div class="pull-refresh-bar" [style.height.px]="pullDistance" [class.ready]="readyToRefresh" [class.snapping]="isSnapping">
        <span class="material-symbols-rounded ptr-icon">{{ readyToRefresh ? 'refresh' : 'arrow_downward' }}</span>
    </div>

    <header>
        <div class="user-greeting">
            <p class="subtitle">Bom dia<span *ngIf="greetingName">, {{ greetingName }}</span></p>
            <h1 class="page-title">Painel da Oficina</h1>
            <p class="filial-name" *ngIf="filialName">{{ filialName }}</p>
            <div class="panel-tabs" *ngIf="canApproveOs">
                <button type="button" class="panel-tab-btn active" disabled>
                    <span class="material-symbols-rounded">check_circle</span>
                    Painel Criação OS
                </button>
                <button type="button" class="panel-tab-btn" (click)="goToOsApproval()">
                    <span class="material-symbols-rounded">sync_alt</span>
                    Painel Aprovação OS
                </button>
            </div>
        </div>
        <div class="user-avatar avatar" (click)="toggleMenu()" style="cursor: pointer; position: relative;">
            <span class="material-symbols-rounded">person</span>

            <div class="menu-overlay" *ngIf="isMenuOpen" (click)="closeMenu(); $event.stopPropagation()"></div>
            <div class="menu-wrapper" *ngIf="isMenuOpen">
                <app-profile-menu (close)="closeMenu()"></app-profile-menu>
            </div>
        </div>
    </header>

    <section class="search-section">
        <div class="input-group">
            <span class="material-symbols-rounded input-icon">search</span>
            <input type="text" [formControl]="searchControl" (keydown.enter)="submitSearch()"
                placeholder="Buscar placa, cliente ou OS #...">
            <button type="button" class="qr-code-btn btn-icon-only" (click)="submitSearch()">
                <span class="material-symbols-rounded search-spinner" [class.spinning]="isSearching">search</span>
            </button>
        </div>
    </section>

    <section class="action-section">
        <button class="new-os-btn btn-primary" (click)="goToNewOS()">
            <div class="btn-content">
                <span class="btn-title">+ NOVA ORDEM DE SERVIÇO</span>
                <span class="btn-subtitle">Iniciar check-in de novo veículo</span>
            </div>
            <div class="btn-icon avatar">
                <span class="material-symbols-rounded">add_circle</span>
            </div>
        </button>
    </section>

    <section class="list-section">
        <div class="section-header">
            <h2 class="section-title">Ordens de Serviço</h2>
            <div class="tabs" *ngIf="!hasActiveSearch">
                <button type="button" class="tab-btn" [class.active]="activeTab === 'rascunhos'"
                    (click)="setActiveTab('rascunhos')">
                    Rascunhos
                </button>
                <button type="button" class="tab-btn" [class.active]="activeTab === 'abertos'"
                    (click)="setActiveTab('abertos')">
                    Abertos
                </button>
                <button type="button" class="tab-btn" [class.active]="activeTab === 'ultima-semana'"
                    (click)="setActiveTab('ultima-semana')">
                    Última semana
                </button>
            </div>
            <div class="tabs" *ngIf="hasActiveSearch">
                <button type="button" class="tab-btn" *ngFor="let status of statusFilters"
                    [class.active]="activeStatusFilter === status" (click)="setStatusFilter(status)">
                    {{ status }}
                </button>
            </div>
        </div>

        <div class="list-feedback"
            *ngIf="isSearchPending || isLoadingOrders || loadOrdersError || (!(isSearchPending || isLoadingOrders) && !loadOrdersError && filteredOrders.length === 0)">
            <app-loader *ngIf="isSearchPending || isLoadingOrders" message="Carregando ordens de serviço..."></app-loader>
            <p class="helper-text error-text" *ngIf="!(isSearchPending || isLoadingOrders) && loadOrdersError">{{ loadOrdersError }}</p>
            <!-- <div class="empty-state" *ngIf="!isLoadingOrders && !loadOrdersError && filteredOrders.length === 0">
                <img src="assets/images/missing.svg" alt="Nenhuma ordem encontrada" class="empty-state__img" />
                <p class="empty-state__title">Nenhuma OS encontrada</p>
                <p class="empty-state__sub" *ngIf="activeTab === 'rascunhos'">Rascunhos salvos aparecerão aqui.</p>
                <p class="empty-state__sub" *ngIf="activeTab === 'abertos'">Não há ordens abertas no momento.</p>
                <p class="empty-state__sub" *ngIf="activeTab === 'ultima-semana'">Nenhuma OS foi aberta na última semana.</p>
            </div> -->
            <div class="empty-all-good" *ngIf="!(isSearchPending || isLoadingOrders) && !loadOrdersError && filteredOrders.length === 0">
                <span class="material-symbols-rounded check-icon">check_circle</span>
                <span class="status-text">TUDO EM DIA</span>
            </div>
        </div>

        <div class="order-list">
            <div *ngFor="let order of filteredOrders" (click)="navigateToOrder(order)">
                <app-service-card [order]="order"></app-service-card>
            </div>
        </div>
    </section>

    <div class="status-footer">
        <app-loader *ngIf="isLoadingMore" size="sm" message="Carregando mais ordens..."></app-loader>
        <div class="status-all-good" *ngIf="filteredOrders.length > 0 && !isLoadingOrders && !isLoadingMore && !loadOrdersError && !hasNextPage">
            <span class="material-symbols-rounded check-icon">check_circle</span>
            <span class="status-text">TUDO EM DIA</span>
        </div>
    </div>
</div>
